import axios from 'axios';
import { useEffect, useState } from 'react';
import { getToken, windowReload } from '../utils';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export function useNotifications() {
  const { token: userToken } = getToken();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const newNotifications = notifications?.filter(
    (notification) => notification.status === '0'
  );

  const handleClearNotification = async () => {
    setIsSubmiting(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/notifications/clear-all`,
        {},
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      toast.success(response.data.message);
      windowReload();
    } catch (error) {
      toast.error('Error occured!');
      console.log(error);
    } finally {
      setIsSubmiting(false);
    }
  };

  const handleMarkNotification = async (id) => {
    if (
      notifications.find((notification) => notification.id === id).status ===
      '1'
    ) {
      return;
    }

    try {
      setIsSubmiting(true);
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/notifications/mark-read`,
        { notification_id: id },
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      window.location.reload();
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSubmiting(false);
    }
  };

  const handleClickedNotification = (id) => {
    const clickedMessage = notifications.find((data) => {
      return data.id === id;
    });

    window.sessionStorage.setItem(
      'notification',
      JSON.stringify(clickedMessage)
    );
  };

  const goToNotification = (id) => {
    navigate(`/notifications/${id}`);
    handleClickedNotification(id);
    handleMarkNotification(id);
  };

  useEffect(() => {
    const getNotifications = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/notifications`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setNotifications(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getNotifications();
  }, [userToken]);

  return {
    isLoading,
    isSubmiting,
    notifications,
    newNotifications,
    handleClearNotification,
    handleMarkNotification,
    handleClickedNotification,
    goToNotification,
  };
}
